import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
export const FilterAccordionId = {
  Grade: 'grade',
  Semester: 'semester',
  Subject: 'subject',
  TemplateType: 'templateType',
  QuestionSize: 'questionSize',
  SubjectGroup: 'subjectGroup',
  SubSubject: 'subSubject'
} as const;
export type FilterAccordionIdType = (typeof FilterAccordionId)[keyof typeof FilterAccordionId];
const initValue = [FilterAccordionId.Grade, FilterAccordionId.Semester, FilterAccordionId.Subject];
interface SubjectFilterExpandedItemsParams {
  expandedItems: string[];
  subjectGroupId: string;
  shouldExpandSubjectGroup: boolean;
}
export const getExpandedItemsForSubjectFilterSelection = ({
  expandedItems,
  subjectGroupId,
  shouldExpandSubjectGroup
}: SubjectFilterExpandedItemsParams) => {
  const expandedItemsWithoutSubjectGroups = expandedItems.filter(item => !item.startsWith(FilterAccordionId.SubjectGroup));
  const expandedItemsWithSubject = expandedItemsWithoutSubjectGroups.includes(FilterAccordionId.Subject) ? expandedItemsWithoutSubjectGroups : [...expandedItemsWithoutSubjectGroups, FilterAccordionId.Subject];
  if (!shouldExpandSubjectGroup) {
    return expandedItemsWithSubject;
  }
  return [...expandedItemsWithSubject, FilterAccordionId.SubjectGroup + subjectGroupId];
};
const expandedItemsAtom = atomWithStorage<string[]>('filterExpandItems', initValue);
export const useAccordionStorage = () => {
  const [expandedItems, setExpandedItems] = useAtom(expandedItemsAtom);
  const handleExpandItems = (newExpandedItems: string[]) => {
    setExpandedItems(newExpandedItems);
  };
  const collapseSubjectGroup = (subjectGroupId: string) => {
    return setExpandedItems(expandedItems.filter(item => item !== FilterAccordionId.SubjectGroup + subjectGroupId));
  };
  const resetAccordion = () => {
    setExpandedItems(initValue);
  };
  return {
    expandedItems,
    handleExpandItems,
    collapseSubjectGroup,
    resetAccordion
  };
};